/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Popup_Recentdeliveries_Signintosee4Inputs */

const he_extension_popup_recentdeliveries_signintosee4 = /** @type {(inputs: Extension_Popup_Recentdeliveries_Signintosee4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התחבר כדי לראות`)
};

const en_extension_popup_recentdeliveries_signintosee4 = /** @type {(inputs: Extension_Popup_Recentdeliveries_Signintosee4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to see`)
};

/**
* | output |
* | --- |
* | "Sign in to see" |
*
* @param {Extension_Popup_Recentdeliveries_Signintosee4Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_popup_recentdeliveries_signintosee4 = /** @type {((inputs?: Extension_Popup_Recentdeliveries_Signintosee4Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Popup_Recentdeliveries_Signintosee4Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_popup_recentdeliveries_signintosee4(inputs)
	return en_extension_popup_recentdeliveries_signintosee4(inputs)
});
export { extension_popup_recentdeliveries_signintosee4 as "extension_popup_recentDeliveries_signInToSee" }